import { render } from 'preact'
import { Home } from './Home'
import { Share } from './Share'
import './styles.css'

/**
 * 路由只有兩條，不值得拉一個 router 進來。
 * /share 是 Web Share Target 的落地頁，其他一律首頁。
 */
function App() {
  return location.pathname === '/share' ? <Share /> : <Home />
}

const root = document.getElementById('app')
if (root) render(<App />, root)
